/**
 * Real-user monitoring: Core Web Vitals -> Mixpanel.
 *
 * Why this exists: FCP by page path is aggregated over a whole period and only describes
 * first paint, so it cannot answer "the site felt slow today". This sends LCP, INP, CLS,
 * FCP and TTFB per session, joined to the same distinct_id (lowercased email) the rest of
 * the theme uses, so a specific complaint can be looked up rather than guessed at.
 *
 * One event per page load, not one per metric: LCP, CLS and INP are only final when the
 * page is hidden anyway, and batching keeps this to a single extra event per pageview.
 */
(function () {
  // Fraction of page loads reported. 1 = every load. Worth keeping at 1 while establishing
  // a before/after baseline; drop to ~0.25 afterwards if the event volume bites — even a
  // quarter of traffic is far more than enough to hold a stable daily P75.
  var SAMPLE = 1;
  var EVENT_NAME = 'web_vitals';

  if (!window.webVitals) return;
  if (Math.random() >= SAMPLE) return;

  var metrics = {};
  var navigationType = null;
  var sent = false;

  function record(metric) {
    var key = metric.name.toLowerCase();
    // CLS is a unitless score in the 0-1 range; every other metric is milliseconds.
    metrics[key] = key === 'cls'
      ? Math.round(metric.value * 10000) / 10000
      : Math.round(metric.value);
    metrics[key + '_rating'] = metric.rating;
    if (metric.navigationType) navigationType = metric.navigationType;
  }

  function hasMetrics() {
    for (var key in metrics) {
      if (Object.prototype.hasOwnProperty.call(metrics, key)) return true;
    }
    return false;
  }

  function assign(target, source) {
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
  }

  function properties() {
    var conn = navigator.connection || {};
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};

    var props = {
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      device_pixel_ratio: window.devicePixelRatio || 1,
      // Coarse device-capability signals. These are what separate "our code is slow" from
      // "this person is on a cheap phone on a bad connection".
      effective_connection: conn.effectiveType || null,
      connection_rtt: typeof conn.rtt === 'number' ? conn.rtt : null,
      connection_downlink: typeof conn.downlink === 'number' ? conn.downlink : null,
      save_data: conn.saveData === true,
      device_memory_gb: navigator.deviceMemory || null,
      cpu_cores: navigator.hardwareConcurrency || null,
      // A bfcache restore paints instantly and would otherwise flatter the numbers.
      navigation_type: navigationType || nav.type || null
    };

    // Template, market and theme, emitted by layout/theme.liquid. theme_name is what lets a
    // preview theme be compared against the live one under identical real-world conditions.
    if (window.__rumContext) assign(props, window.__rumContext);
    return assign(props, metrics);
  }

  function flush() {
    if (sent || !hasMetrics()) return;
    if (!window.mixpanel || typeof window.mixpanel.track !== 'function') return;

    sent = true;
    // sendBeacon survives the unload this listener is reacting to; a normal XHR would
    // usually be cancelled.
    window.mixpanel.track(EVENT_NAME, properties(), { transport: 'sendBeacon' });
  }

  window.webVitals.onLCP(record);
  window.webVitals.onINP(record);
  window.webVitals.onCLS(record);
  window.webVitals.onFCP(record);
  window.webVitals.onTTFB(record);

  // Registered after the onX calls on purpose. web-vitals attaches its own visibilitychange
  // listener inside each of those, and listeners fire in registration order — so by the time
  // this one runs, the final LCP/CLS/INP values have already been recorded.
  addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  addEventListener('pagehide', flush);
})();
